var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{on_desktop: _vm.$vuetify.breakpoint.smAndUp},staticStyle:{"height":"100%","max-width":"600px","margin":"auto"}},[_c('v-main',{staticClass:"grey lighten-3"},[_vm._t("default",function(){return [_c('router-view')]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }